import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import weddingBackground from '../assets/weddingdavet.png';
import weddingIllustration from '../assets/a-joyful-bride-and-groom-walking-hand-in-hand-on-a (1).png';
import coupleImage from '../assets/a-joyful-bride-and-groom-walking-hand-in-hand-on-a (1).png';
import beachProposal from '../assets/a-joyful-bride-and-groom-walking-hand-in-hand-on-a.png';
import flowerImage from '../assets/Black_and_White_Minimalist_Fashion_Store_Logo__1_-removebg-preview.png';
import hotelImage from '../assets/a-realistic-and-aesthetic-image-of-a-hotel-taken-f (1).png';
import weddingMusic from '../assets/wedding2music.mp3';

const Wedding2 = () => {
    const navigate = useNavigate();

    // Slayt gösterisi için görsel dizisi
    const images = [
        { src: weddingIllustration, alt: "Düğün İllüstrasyonu" },
        { src: coupleImage, alt: "Düğün Çifti" },
        { src: beachProposal, alt: "Evlilik Teklifi" }
    ];

    // Aktif görsel indeksi
    const [activeIndex, setActiveIndex] = useState(0);

    // Müzik kontrolü
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);

    // Mektup formu için state'ler
    const [letterName, setLetterName] = useState('');
    const [letterMessage, setLetterMessage] = useState('');

    // Geri sayım için hedef tarih (3 Temmuz 2025)
    const targetDate = new Date('2025-07-03T18:00:00').getTime();
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    function calculateTimeLeft() {
        const now = new Date().getTime();
        const difference = targetDate - now;

        if (difference > 0) {
            return {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
                seconds: Math.floor((difference % (1000 * 60)) / 1000)
            };
        }
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    // Otomatik slayt değişimi
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((current) => (current + 1) % images.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [images.length]);

    // Geri sayım timer
    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [targetDate]);

    // Audio element'ini yapılandırma
    useEffect(() => {
        // Sayfa yüklendiğinde en üste scroll et
        window.scrollTo(0, 0);

        if (audioRef.current) {
            audioRef.current.volume = 0.5; // Ses seviyesini %50 yap
        }

        // Component unmount olduğunda müziği durdur
        return () => {
            if (audioRef.current) {
                audioRef.current.pause();
                setIsPlaying(false);
            }
        };
    }, []);

    // Manuel slayt değişimi
    const goToSlide = (index) => {
        setActiveIndex(index);
    };

    // Çerçeve rengi
    const frameColor = "#e4ddd3";

    // Düğün bilgileri
    const weddingInfo = {
        date: "3 Temmuz 2025",
        time: "18:00",
        venue: "Salon Seramoni 3-4",
        address: "Salon Seramoni 3-4, İstanbul",
        mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3011.215175085331!2d28.711305476424613!3d40.99866332001621!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caa0febc2e47eb%3A0xfbbf372aca654bda!2sSalon%20Seramoni%203-4!5e0!3m2!1str!2str!4v1751276772794!5m2!1str!2str",
        googleMapsUrl: "https://www.google.com/maps/place/Salon+Seramoni+3-4/@40.9986633,28.7113055,17z/data=!3m1!4b1!4m6!3m5!1s0x14caa0febc2e47eb:0xfbbf372aca654bda!8m2!3d40.9986633!4d28.7138804!16s%2Fg%2F11qp8l0_6k?entry=ttu"
    };

    // Google Haritalar'ı açma fonksiyonu
    const openInGoogleMaps = () => {
        window.open(weddingInfo.googleMapsUrl, '_blank');
    };

    // Müzik kontrol fonksiyonu
    const toggleMusic = () => {
        if (audioRef.current) {
            if (!isPlaying) {
                audioRef.current.play()
                    .then(() => {
                        setIsPlaying(true);
                        console.log('Müzik başlatıldı');
                    })
                    .catch((error) => {
                        console.error('Müzik başlatılamadı:', error);
                    });
            } else {
                audioRef.current.pause();
                setIsPlaying(false);
                console.log('Müzik durduruldu');
            }
        }
    };

    // Scroll down fonksiyonu
    const scrollToDetails = () => {
        const detailsSection = document.querySelector('.venue-details-section');
        if (detailsSection) {
            detailsSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    // PDF indirme fonksiyonu
    const downloadLetterAsPDF = async () => {
        if (!letterName.trim() || !letterMessage.trim()) {
            alert('Lütfen hem isminizi hem de mesajınızı yazın.');
            return;
        }

        try {
            // PDF oluştur
            generatePDFFromHTML();
        } catch (error) {
            console.error('PDF indirme hatası:', error);
            alert('PDF oluşturulurken bir hata oluştu. Lütfen tekrar deneyin.');
        }
    };



    const generatePDFFromHTML = () => {
        // Mobil cihaz kontrolü
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;

        // Tarih formatı
        const currentDate = new Date().toLocaleDateString('tr-TR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });

        // Mobil için optimize edilmiş boyutlar - Yatay (landscape) format
        const containerWidth = isMobile ? 1000 : 800;
        const containerHeight = isMobile ? 700 : 1000;
        const padding = isMobile ? 40 : 60;
        const fontSize = {
            title: isMobile ? 24 : 36,
            date: isMobile ? 14 : 18,
            greeting: isMobile ? 18 : 24,
            content: isMobile ? 16 : 20,
            closing: isMobile ? 16 : 20,
            signature: isMobile ? 18 : 24,
            footer: isMobile ? 11 : 14
        };

        // Geçici HTML içeriği oluştur
        const pdfContent = document.createElement('div');
        pdfContent.style.cssText = `
            width: ${containerWidth}px;
            height: ${containerHeight}px;
            padding: ${padding}px;
            background: linear-gradient(45deg, #fdfcf8 25%, transparent 25%), 
                        linear-gradient(-45deg, #fdfcf8 25%, transparent 25%), 
                        linear-gradient(45deg, transparent 75%, #fdfcf8 75%), 
                        linear-gradient(-45deg, transparent 75%, #fdfcf8 75%),
                        #fefef9;
            background-size: 20px 20px;
            background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
            border: 3px solid #e8dcc0;
            font-family: 'Dancing Script', cursive;
            position: absolute;
            top: -10000px;
            left: -10000px;
            box-sizing: border-box;
            transform: scale(1);
            transform-origin: top left;
        `;

        const innerPadding = isMobile ? 30 : 40;
        const decorationSize = isMobile ? 25 : 30;

        pdfContent.innerHTML = `
            <div style="border: 2px solid rgba(255,193,7,0.3); border-radius: 15px; padding: ${innerPadding}px; height: calc(100% - ${padding * 2}px); position: relative; overflow: hidden;">
                <!-- Köşe süslemeleri -->
                <div style="position: absolute; top: 15px; left: 15px; width: ${decorationSize}px; height: ${decorationSize}px; background: #c17557; border-radius: 50%; opacity: 0.3;"></div>
                <div style="position: absolute; top: 15px; right: 15px; width: ${decorationSize}px; height: ${decorationSize}px; background: #c17557; border-radius: 50%; opacity: 0.3;"></div>
                <div style="position: absolute; bottom: 15px; left: 15px; width: ${decorationSize}px; height: ${decorationSize}px; background: #c17557; border-radius: 50%; opacity: 0.3;"></div>
                <div style="position: absolute; bottom: 15px; right: 15px; width: ${decorationSize}px; height: ${decorationSize}px; background: #c17557; border-radius: 50%; opacity: 0.3;"></div>
                
                <!-- Başlık -->
                <h1 style="text-align: center; color: #6d5852; font-size: ${fontSize.title}px; margin-bottom: ${isMobile ? 30 : 40}px; font-weight: 700; word-wrap: break-word;">
                    Cansu & Ali'ye Mektup
                </h1>
                
                <!-- Tarih -->
                <div style="text-align: right; color: #8b6f61; font-size: ${fontSize.date}px; margin-bottom: ${isMobile ? 30 : 40}px;">
                    ${currentDate}
                </div>
                
                <!-- Selam -->
                <div style="color: #6d5852; font-size: ${fontSize.greeting}px; margin-bottom: ${isMobile ? 25 : 30}px; font-weight: 600;">
                    Sevgili Cansu & Ali,
                </div>
                
                <!-- Mesaj İçeriği -->
                <div style="color: #6d5852; font-size: ${fontSize.content}px; line-height: 1.8; margin-bottom: ${isMobile ? 30 : 40}px; min-height: ${isMobile ? 200 : 300}px; padding-left: 20px; border-left: 2px solid #c17557; position: relative; word-wrap: break-word; overflow-wrap: break-word;">
                    <div style="position: absolute; left: -20px; top: 0; bottom: 0; width: 2px; background: #c17557; opacity: 0.3;"></div>
                    ${letterMessage.split('\n').map(line => `<div style="margin-bottom: 12px; word-wrap: break-word;">${line || '&nbsp;'}</div>`).join('')}
                </div>
                
                <!-- Kapanış -->
                <div style="text-align: right; color: #8b6f61; font-size: ${fontSize.closing}px; margin-bottom: 20px; font-style: italic;">
                    Sevgi ve saygılarımla...
                </div>
                
                <!-- İmza -->
                <div style="text-align: right; color: #6d5852; font-size: ${fontSize.signature}px; margin-bottom: ${isMobile ? 25 : 30}px; font-weight: 600; word-wrap: break-word;">
                    ${letterName}
                </div>
                
                <!-- Dekoratif çizgi -->
                <div style="width: 100%; height: 2px; background: linear-gradient(to right, transparent, #c17557, transparent); margin: ${isMobile ? 25 : 30}px 0;"></div>
                
                <!-- Alt bilgi -->
                <div style="text-align: center; color: #999; font-size: ${fontSize.footer}px; font-style: italic; word-wrap: break-word;">
                    Bu mektup Cansu & Ali'nin düğün davetiyesi ile birlikte Dijivite firmasıyla hazırlanmıştır.
                </div>
            </div>
        `;

        // DOM'a ekle
        document.body.appendChild(pdfContent);

        // Mobil için optimize edilmiş html2canvas ayarları
        const canvasOptions = {
            scale: isMobile ? 2 : 3,
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#fefef9',
            width: containerWidth,
            height: containerHeight,
            scrollX: 0,
            scrollY: 0,
            windowWidth: containerWidth,
            windowHeight: containerHeight,
            logging: false,
            removeContainer: true,
            foreignObjectRendering: false
        };

        // HTML2Canvas ile görüntüyü çek
        html2canvas(pdfContent, canvasOptions).then(canvas => {
            try {
                // DOM'dan temizle
                if (document.body.contains(pdfContent)) {
                    document.body.removeChild(pdfContent);
                }

                // PDF oluştur

                // Canvas boyutlarına göre PDF boyutunu hesapla
                const canvasWidth = canvas.width;
                const canvasHeight = canvas.height;
                const aspectRatio = canvasHeight / canvasWidth;

                // A4 boyutları (mm)
                const a4Width = 210;
                const a4Height = 297;

                // PDF boyutunu canvas oranına göre ayarla
                let pdfWidth, pdfHeight;

                // Mobil cihazlarda her zaman yatay (landscape) format kullan
                if (isMobile) {
                    pdfWidth = a4Height; // 297mm
                    pdfHeight = a4Width; // 210mm
                } else {
                    if (aspectRatio > a4Height / a4Width) {
                        // Yükseklik sınırlayıcı
                        pdfHeight = a4Height;
                        pdfWidth = a4Height / aspectRatio;
                    } else {
                        // Genişlik sınırlayıcı
                        pdfWidth = a4Width;
                        pdfHeight = a4Width * aspectRatio;
                    }
                }

                const pdf = new jsPDF({
                    orientation: isMobile ? 'landscape' : (pdfWidth > pdfHeight ? 'landscape' : 'portrait'),
                    unit: 'mm',
                    format: [pdfWidth, pdfHeight]
                });

                const imgData = canvas.toDataURL('image/png', 1.0);
                pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight, undefined, 'FAST');

                // PDF'i indir
                pdf.save(`Cansu_ve_Ali_Mektup_${letterName.replace(/\s+/g, '_')}.pdf`);

                // Başarı mesajı
                setTimeout(() => {
                    alert('Mektubunuz başarıyla indirildi! ❤️');
                }, 500);

            } catch (pdfError) {
                console.error('PDF oluşturma hatası:', pdfError);
                alert('PDF oluşturulurken bir hata oluştu. Lütfen tekrar deneyin.');
            }
        }).catch(error => {
            console.error('Canvas oluşturma hatası:', error);
            alert('PDF oluşturulurken bir hata oluştu. Lütfen tekrar deneyin.');
            if (document.body.contains(pdfContent)) {
                document.body.removeChild(pdfContent);
            }
        });
    };

    return (
        <div className="w-full">
            {/* Geri Dönme Butonu */}
            <button
                onClick={() => navigate('/calismalarimiz')}
                className="fixed top-6 left-6 z-50 bg-white/90 backdrop-blur-sm hover:bg-white text-gray-700 hover:text-gray-900 p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 border border-gray-200/50"
                aria-label="Çalışmalarımıza Geri Dön"
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
            </button>

            {/* Gizli Audio Element */}
            <audio
                ref={audioRef}
                src={weddingMusic}
                loop
                preload="auto"
                onEnded={() => setIsPlaying(false)}
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
            />

            {/* CSS Animasyonları ve Font Tanımı */}
            <style jsx>{`
                @import url('https://fonts.googleapis.com/css2?family=Alex+Brush&family=Dancing+Script:wght@400;500;600;700&display=swap');
                
                @keyframes floatFlower {
                    0%, 100% {
                        transform: translateY(0px) rotate(0deg);
                    }
                    50% {
                        transform: translateY(-10px) rotate(2deg);
                    }
                }
                
                @keyframes fadeInScale {
                    0% {
                        opacity: 0;
                        transform: scale(0.8);
                    }
                    100% {
                        opacity: 1;
                        transform: scale(1);
                    }
                }
                
                .flower-animation {
                    animation: floatFlower 3s ease-in-out infinite, fadeInScale 1s ease-out;
                }

                .wedding-text {
                    font-family: 'Alex Brush', cursive;
                }

                .couple-names {
                    font-family: 'Alex Brush', cursive;
                    color: #c17557;
                    text-shadow: 2px 2px 4px rgba(0,0,0,0.1);
                    font-weight: 700;
                }

                .couple-text {
                    display: inline-block;
                    margin: 0 0.5rem;
                }

                .venue-section {
                    background: linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.8) 100%);
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255,255,255,0.2);
                }

                .map-container {
                    border-radius: 15px;
                    overflow: hidden;
                    box-shadow: 0 8px 25px rgba(0,0,0,0.1);
                }

                .venue-info {
                    background: rgba(255,255,255,0.95);
                    backdrop-filter: blur(5px);
                }

                .music-control {
                    position: relative;
                    background: linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 100%);
                    backdrop-filter: blur(15px);
                    border: 2px solid rgba(199,117,87,0.4);
                    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                    box-shadow: 
                        0 8px 32px rgba(199,117,87,0.25),
                        0 4px 16px rgba(0,0,0,0.15),
                        inset 0 1px 0 rgba(255,255,255,0.8);
                }

                .music-control::before {
                    content: '';
                    position: absolute;
                    inset: -3px;
                    background: conic-gradient(from 0deg, #c17557, #e4ddd3, #f4a261, #c17557, #e4ddd3, #c17557);
                    border-radius: 50%;
                    z-index: -1;
                    opacity: 0;
                    transition: opacity 0.3s ease;
                    animation: rotateGradient 3s linear infinite;
                    filter: saturate(1.3);
                }

                @keyframes rotateGradient {
                    0% {
                        transform: rotate(0deg);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }

                .music-control:hover::before {
                    opacity: 1;
                }

                .music-control:hover::after {
                    opacity: 0.6;
                }

                .music-control::after {
                    content: '';
                    position: absolute;
                    inset: -4px;
                    background: conic-gradient(from 180deg, 
                        rgba(193,117,87,0.9), 
                        rgba(244,162,97,1), 
                        rgba(228,221,211,0.8), 
                        rgba(193,117,87,0.9)
                    );
                    border-radius: 50%;
                    z-index: -2;
                    opacity: 0;
                    animation: rotateGradientReverse 4s linear infinite;
                    filter: blur(2px);
                }

                .music-playing::after {
                    opacity: 0.7;
                }

                @keyframes rotateGradientReverse {
                    0% {
                        transform: rotate(360deg);
                    }
                    100% {
                        transform: rotate(0deg);
                    }
                }

                .music-control:hover {
                    transform: scale(1.08) translateY(-2px);
                    box-shadow: 
                        0 12px 40px rgba(199,117,87,0.35),
                        0 8px 24px rgba(0,0,0,0.2),
                        inset 0 1px 0 rgba(255,255,255,0.9);
                    border-color: rgba(199,117,87,0.6);
                }

                .music-control:active {
                    transform: scale(1.02) translateY(-1px);
                }

                .music-icon {
                    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                    filter: drop-shadow(0 2px 4px rgba(109,88,82,0.2));
                }

                .music-control:hover .music-icon {
                    transform: scale(1.15);
                    filter: drop-shadow(0 4px 8px rgba(109,88,82,0.3));
                }



                .music-control:hover + .music-text-container .music-text {
                    transform: translateY(-2px);
                    color: #c17557 !important;
                }

                @keyframes musicPulse {
                    0%, 100% {
                        box-shadow: 
                            0 8px 32px rgba(199,117,87,0.25),
                            0 4px 16px rgba(0,0,0,0.15),
                            0 0 0 0 rgba(199,117,87,0.4);
                    }
                    50% {
                        box-shadow: 
                            0 8px 32px rgba(199,117,87,0.25),
                            0 4px 16px rgba(0,0,0,0.15),
                            0 0 0 10px rgba(199,117,87,0.2);
                    }
                }

                .music-playing {
                    animation: musicPulse 2s infinite;
                }

                .scroll-indicator {
                    background: rgba(255,255,255,0.9);
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(199,117,87,0.4);
                    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                    box-shadow: 0 4px 20px rgba(199,117,87,0.2);
                }

                .scroll-indicator:hover {
                    transform: translateY(-3px);
                    background: rgba(255,255,255,0.95);
                    border-color: rgba(199,117,87,0.6);
                    box-shadow: 0 8px 30px rgba(199,117,87,0.3);
                }

                .scroll-arrow {
                    transition: all 0.3s ease;
                    animation: scrollBounce 2s ease-in-out infinite;
                }

                .scroll-indicator:hover .scroll-arrow {
                    transform: translateY(2px);
                    color: #c17557 !important;
                }

                @keyframes scrollBounce {
                    0%, 100% {
                        transform: translateY(0px);
                    }
                    50% {
                        transform: translateY(-3px);
                    }
                }

                .scroll-text {
                    font-size: 16px;
                    font-weight: 700;
                    letter-spacing: 0.5px;
                    transition: all 0.3s ease;
                    text-shadow: 0 2px 4px rgba(255,255,255,0.8);
                }

                .scroll-indicator:hover .scroll-text {
                    color: #c17557 !important;
                    transform: translateY(-2px);
                }

                .music-text {
                    font-size: 16px;
                    font-weight: 700;
                    letter-spacing: 0.5px;
                    text-shadow: 0 2px 4px rgba(255,255,255,0.8);
                    transition: all 0.3s ease;
                }
            `}</style>

            {/* İlk Section - Hero Area (Arka plan görseli ile) */}
            <div className="relative h-screen w-full overflow-hidden">
                {/* Arka plan görseli - sadece hero section için */}
                <div
                    className="absolute inset-0 z-0"
                    style={{
                        backgroundImage: `url(${weddingBackground})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        opacity: 0.9,
                    }}
                />

                {/* Orta alanda çerçeve içinde görsel slayt */}
                <div className="relative z-10 h-full flex items-start justify-center px-4 pt-4 pb-8">
                    <div className="relative">
                        {/* Dış çerçeve */}
                        <div
                            className="relative"
                            style={{
                                width: "min(70vw, 350px)",
                                transform: "rotate(-2deg)",
                                boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                                backgroundColor: frameColor,
                                paddingTop: "12px",
                                paddingLeft: "12px",
                                paddingRight: "12px",
                            }}
                        >
                            {/* Görsel kısmı */}
                            <div className="w-full aspect-square border-2 border-gray-200 relative overflow-hidden bg-white">
                                {/* Görsel slaytı */}
                                <div className="w-full h-full relative p-2">
                                    {images.map((image, index) => (
                                        <div
                                            key={index}
                                            className={`absolute inset-0 transition-opacity duration-1000 ${index === activeIndex ? 'opacity-100' : 'opacity-0'}`}
                                        >
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="w-full h-full object-cover"
                                                style={{ objectPosition: "center" }}
                                            />
                                        </div>
                                    ))}
                                </div>

                                {/* Slayt noktaları */}
                                <div className="absolute bottom-2 left-0 right-0 flex justify-center space-x-2 z-20">
                                    {images.map((_, index) => (
                                        <button
                                            key={index}
                                            onClick={() => goToSlide(index)}
                                            className={`w-2 h-2 rounded-full ${index === activeIndex ? 'bg-white' : 'bg-white/50'}`}
                                            aria-label={`Slayt ${index + 1}`}
                                        />
                                    ))}
                                </div>
                            </div>

                            {/* Alt uzantı kısmı - "evleniyoruz" yazısı */}
                            <div className="w-full py-4 pl-6" style={{ backgroundColor: frameColor }}>
                                <p className="wedding-text text-2xl text-gray-700">evleniyoruz</p>
                            </div>
                        </div>

                        {/* Animasyonlu çiçek - sağ alt köşede */}
                        <div className="absolute -bottom-12 -right-12 w-48 h-48 md:w-64 md:h-64 lg:w-72 lg:h-72 z-30 flower-animation">
                            <img
                                src={flowerImage}
                                alt="Çiçek Dekorasyonu"
                                className="w-full h-full object-contain"
                                style={{ filter: 'drop-shadow(2px 4px 6px rgba(0,0,0,0.1))' }}
                            />
                        </div>

                        {/* Çiftin İsimleri */}
                        <div className="absolute -bottom-24 left-1/2 transform -translate-x-1/2 text-center z-20 whitespace-nowrap">
                            <h2 className="couple-names text-6xl md:text-7xl lg:text-8xl">
                                <span className="couple-text">Cansu</span>
                                <span className="couple-text">&</span>
                                <span className="couple-text">Ali</span>
                            </h2>
                        </div>

                        {/* Davet Yazısı */}
                        <div className="absolute -bottom-36 left-1/2 transform -translate-x-1/2 text-center z-20">
                            <p className="wedding-text text-lg md:text-xl whitespace-nowrap" style={{ color: '#6d5852' }}>
                                Sizleri de aramızda görmekten mutluluk duyacağız
                            </p>
                        </div>

                        {/* Geri Sayım Sayacı ve Butonlar Container */}
                        <div className="absolute -bottom-60 left-1/2 transform -translate-x-1/2 text-center z-20">
                            {/* Masaüstü Görünümü - Sayaç ve Butonlar Yan Yana */}
                            <div className="hidden lg:flex items-center justify-center space-x-8">
                                {/* Müzik Butonu - Sol */}
                                <div className="text-center">
                                    <button
                                        onClick={toggleMusic}
                                        className={`music-control w-16 h-16 rounded-full flex items-center justify-center ${isPlaying ? 'music-playing' : ''}`}
                                        aria-label={isPlaying ? "Müziği Durdur" : "Müziği Başlat"}
                                    >
                                        {isPlaying ? (
                                            <svg className="music-icon w-7 h-7" fill="currentColor" style={{ color: '#6d5852' }} viewBox="0 0 24 24">
                                                <path d="M6 4c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1s-1-.45-1-1V5c0-.55.45-1 1-1zm12 0c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1s-1-.45-1-1V5c0-.55.45-1 1-1z" />
                                            </svg>
                                        ) : (
                                            <svg className="music-icon w-7 h-7 ml-1" fill="currentColor" style={{ color: '#6d5852' }} viewBox="0 0 24 24">
                                                <path d="M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18c.62-.39.62-1.29 0-1.68L9.54 5.98C8.87 5.55 8 6.03 8 6.82z" />
                                            </svg>
                                        )}
                                    </button>
                                    <div className="mt-2">
                                        <p className="music-text wedding-text text-xs" style={{ color: '#6d5852' }}>
                                            {isPlaying ? 'Çalıyor' : 'Müzik'}
                                        </p>
                                    </div>
                                </div>

                                {/* Geri Sayım Sayacı - Orta */}
                                <div className="flex justify-center space-x-4 bg-white/80 backdrop-blur-sm rounded-lg px-6 py-3 shadow-lg">
                                    <div className="text-center">
                                        <div className="text-2xl font-bold" style={{ color: '#6d5852' }}>
                                            {timeLeft.days.toString().padStart(2, '0')}
                                        </div>
                                        <div className="text-xs text-gray-600">GÜN</div>
                                    </div>
                                    <div className="text-center">
                                        <div className="text-2xl font-bold" style={{ color: '#6d5852' }}>:</div>
                                    </div>
                                    <div className="text-center">
                                        <div className="text-2xl font-bold" style={{ color: '#6d5852' }}>
                                            {timeLeft.hours.toString().padStart(2, '0')}
                                        </div>
                                        <div className="text-xs text-gray-600">SAAT</div>
                                    </div>
                                    <div className="text-center">
                                        <div className="text-2xl font-bold" style={{ color: '#6d5852' }}>:</div>
                                    </div>
                                    <div className="text-center">
                                        <div className="text-2xl font-bold" style={{ color: '#6d5852' }}>
                                            {timeLeft.minutes.toString().padStart(2, '0')}
                                        </div>
                                        <div className="text-xs text-gray-600">DAKİKA</div>
                                    </div>
                                    <div className="text-center">
                                        <div className="text-2xl font-bold" style={{ color: '#6d5852' }}>:</div>
                                    </div>
                                    <div className="text-center">
                                        <div className="text-2xl font-bold" style={{ color: '#6d5852' }}>
                                            {timeLeft.seconds.toString().padStart(2, '0')}
                                        </div>
                                        <div className="text-xs text-gray-600">SANİYE</div>
                                    </div>
                                </div>

                                {/* Detaylar Butonu - Sağ */}
                                <div className="text-center">
                                    <button
                                        onClick={scrollToDetails}
                                        className="scroll-indicator w-16 h-16 rounded-2xl flex flex-col items-center justify-center"
                                        aria-label="Düğün detaylarını görmek için aşağı kaydır"
                                    >
                                        <svg className="scroll-arrow w-5 h-5 mb-1" fill="currentColor" style={{ color: '#6d5852' }} viewBox="0 0 24 24">
                                            <path d="M7.41 8.84L12 13.42l4.59-4.58L18 10.25l-6 6-6-6L7.41 8.84z" />
                                        </svg>
                                        <div className="w-1 h-2 bg-current rounded-full" style={{ color: '#6d5852' }}></div>
                                    </button>
                                    <div className="mt-2">
                                        <p className="scroll-text wedding-text text-xs" style={{ color: '#6d5852' }}>
                                            Detaylar
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Mobil Görünümü - Sadece Sayaç */}
                            <div className="lg:hidden">
                                <div className="flex justify-center space-x-4 bg-white/80 backdrop-blur-sm rounded-lg px-6 py-3 shadow-lg">
                                    <div className="text-center">
                                        <div className="text-2xl font-bold" style={{ color: '#6d5852' }}>
                                            {timeLeft.days.toString().padStart(2, '0')}
                                        </div>
                                        <div className="text-xs text-gray-600">GÜN</div>
                                    </div>
                                    <div className="text-center">
                                        <div className="text-2xl font-bold" style={{ color: '#6d5852' }}>:</div>
                                    </div>
                                    <div className="text-center">
                                        <div className="text-2xl font-bold" style={{ color: '#6d5852' }}>
                                            {timeLeft.hours.toString().padStart(2, '0')}
                                        </div>
                                        <div className="text-xs text-gray-600">SAAT</div>
                                    </div>
                                    <div className="text-center">
                                        <div className="text-2xl font-bold" style={{ color: '#6d5852' }}>:</div>
                                    </div>
                                    <div className="text-center">
                                        <div className="text-2xl font-bold" style={{ color: '#6d5852' }}>
                                            {timeLeft.minutes.toString().padStart(2, '0')}
                                        </div>
                                        <div className="text-xs text-gray-600">DAKİKA</div>
                                    </div>
                                    <div className="text-center">
                                        <div className="text-2xl font-bold" style={{ color: '#6d5852' }}>:</div>
                                    </div>
                                    <div className="text-center">
                                        <div className="text-2xl font-bold" style={{ color: '#6d5852' }}>
                                            {timeLeft.seconds.toString().padStart(2, '0')}
                                        </div>
                                        <div className="text-xs text-gray-600">SANİYE</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Mobil için Müzik ve Detaylar Butonları - Alt kısımda */}
                        <div className="lg:hidden">
                            {/* Müzik Kontrol Butonu - Mobil */}
                            <div className="absolute -bottom-96 left-8 text-center z-20">
                                <button
                                    onClick={toggleMusic}
                                    className={`music-control w-20 h-20 rounded-full flex items-center justify-center ${isPlaying ? 'music-playing' : ''}`}
                                    aria-label={isPlaying ? "Müziği Durdur" : "Müziği Başlat"}
                                >
                                    {isPlaying ? (
                                        <svg className="music-icon w-9 h-9" fill="currentColor" style={{ color: '#6d5852' }} viewBox="0 0 24 24">
                                            <path d="M6 4c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1s-1-.45-1-1V5c0-.55.45-1 1-1zm12 0c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1s-1-.45-1-1V5c0-.55.45-1 1-1z" />
                                        </svg>
                                    ) : (
                                        <svg className="music-icon w-9 h-9 ml-1" fill="currentColor" style={{ color: '#6d5852' }} viewBox="0 0 24 24">
                                            <path d="M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18c.62-.39.62-1.29 0-1.68L9.54 5.98C8.87 5.55 8 6.03 8 6.82z" />
                                        </svg>
                                    )}
                                </button>
                                <div className="music-text-container mt-3">
                                    <p className="music-text wedding-text text-sm" style={{ color: '#6d5852' }}>
                                        {isPlaying ? (
                                            <span className="flex items-center justify-center gap-1">
                                                <span className="w-1 h-1 bg-current rounded-full animate-pulse"></span>
                                                Çalıyor
                                                <span className="w-1 h-1 bg-current rounded-full animate-pulse" style={{ animationDelay: '0.5s' }}></span>
                                            </span>
                                        ) : (
                                            'Müzik'
                                        )}
                                    </p>
                                </div>
                            </div>

                            {/* Scroll Down İndikatörü - Mobil */}
                            <div className="absolute -bottom-96 right-8 text-center z-20">
                                <button
                                    onClick={scrollToDetails}
                                    className="scroll-indicator w-20 h-20 rounded-2xl flex flex-col items-center justify-center"
                                    aria-label="Düğün detaylarını görmek için aşağı kaydır"
                                >
                                    <svg className="scroll-arrow w-7 h-7 mb-1" fill="currentColor" style={{ color: '#6d5852' }} viewBox="0 0 24 24">
                                        <path d="M7.41 8.84L12 13.42l4.59-4.58L18 10.25l-6 6-6-6L7.41 8.84z" />
                                    </svg>
                                    <div className="w-1 h-3 bg-current rounded-full" style={{ color: '#6d5852' }}></div>
                                </button>
                                <div className="scroll-text-container mt-3">
                                    <p className="scroll-text wedding-text" style={{ color: '#6d5852' }}>
                                        Detaylar
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Düğün Konumu ve Tarih Bilgisi Section */}
            <div className="venue-details-section relative min-h-screen flex items-center justify-center px-4 py-12" style={{ backgroundColor: '#f8f6f3' }}>
                <div className="max-w-6xl mx-auto w-full">
                    {/* Başlık */}
                    <div className="text-center mb-12">
                        <h2 className="wedding-text text-5xl md:text-6xl mb-4" style={{ color: '#c17557' }}>
                            Düğün Detayları
                        </h2>
                        <p className="text-lg md:text-xl" style={{ color: '#6d5852' }}>
                            Özel günümüzde bizimle olmanızdan mutluluk duyacağız.
                        </p>
                    </div>

                    {/* Ana İçerik */}
                    <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
                        {/* Sol Taraf - Düğün Bilgileri */}
                        <div className="venue-section rounded-2xl p-8 shadow-lg border border-amber-200/40 relative overflow-hidden">
                            {/* Dekoratif arka plan elementleri */}
                            <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-bl from-amber-200/30 to-transparent rounded-full -mr-20 -mt-20 z-0"></div>
                            <div className="absolute bottom-0 left-0 w-32 h-32 bg-gradient-to-tr from-yellow-200/30 to-transparent rounded-full -ml-10 -mb-10 z-0"></div>

                            <div className="relative z-10">
                                <h3 className="wedding-text text-4xl md:text-5xl mb-8 text-center" style={{ color: '#c17557' }}>
                                    Tarih & Konum
                                </h3>

                                {/* Tarih Bilgisi - Yeniden Tasarlandı */}
                                <div className="venue-info rounded-2xl p-4 mb-6 shadow-lg border border-amber-200/40 transform hover:scale-[1.02] transition-all duration-300">
                                    <div className="flex flex-col sm:flex-row items-center sm:items-start">
                                        <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-3 sm:mb-0 sm:mr-4 shadow-lg" style={{ background: 'linear-gradient(135deg, #c17557 0%, #d4957a 100%)' }}>
                                            <svg className="w-7 h-7 text-white drop-shadow-md" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                                            </svg>
                                        </div>
                                        <div className="text-center sm:text-left flex-1">
                                            <h4 className="text-2xl font-medium mb-1" style={{ color: '#6d5852' }}>
                                                {weddingInfo.date}
                                            </h4>
                                            <div className="flex items-center justify-center sm:justify-start">
                                                <svg className="w-4 h-4 mr-2" fill="currentColor" style={{ color: '#6d5852' }} viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                                </svg>
                                                <p className="text-lg font-medium" style={{ color: '#6d5852' }}>Saat: {weddingInfo.time}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Mekan Bilgisi - Yeniden Tasarlandı */}
                                <div className="venue-info rounded-2xl p-4 mb-6 shadow-lg border border-amber-200/40 transform hover:scale-[1.02] transition-all duration-300">
                                    <div className="flex flex-col sm:flex-row items-center sm:items-start">
                                        <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-3 sm:mb-0 sm:mr-4 shadow-lg" style={{ background: 'linear-gradient(135deg, #c17557 0%, #d4957a 100%)' }}>
                                            <svg className="w-7 h-7 text-white drop-shadow-md" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                            </svg>
                                        </div>
                                        <div className="text-center sm:text-left flex-1">
                                            <h4 className="text-2xl font-medium mb-1" style={{ color: '#6d5852' }}>
                                                {weddingInfo.venue}
                                            </h4>
                                            <p className="text-base font-medium mb-3" style={{ color: '#6d5852' }}>
                                                {weddingInfo.address}
                                            </p>

                                            {/* Haritalar Butonu - Yeniden Tasarlandı */}
                                            <button
                                                onClick={openInGoogleMaps}
                                                className="w-full text-white px-5 py-3 rounded-xl font-medium transition-all duration-300 transform hover:scale-[1.03] hover:shadow-xl shadow-md flex items-center justify-center"
                                                style={{
                                                    background: 'linear-gradient(135deg, #c17557 0%, #d4957a 100%)',
                                                    '&:hover': {
                                                        background: 'linear-gradient(135deg, #a8624a 0%, #c17557 100%)'
                                                    }
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.background = 'linear-gradient(135deg, #a8624a 0%, #c17557 100%)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.background = 'linear-gradient(135deg, #c17557 0%, #d4957a 100%)';
                                                }}
                                            >
                                                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                                                </svg>
                                                Google Haritalar'da Aç
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* İyi Dilekler Formu - Mektup Tasarımı */}
                                <div className="venue-info rounded-2xl p-8 shadow-xl border border-amber-200/40 transform hover:scale-[1.02] transition-all duration-300 relative overflow-hidden">
                                    {/* Dekoratif arka plan */}
                                    <div className="absolute inset-0 bg-gradient-to-br from-amber-50 via-white to-amber-50 opacity-80"></div>
                                    <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-amber-200/20 to-transparent rounded-full -mr-16 -mt-16"></div>
                                    <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-yellow-200/20 to-transparent rounded-full -ml-12 -mb-12"></div>

                                    <div className="relative z-10">
                                        <h4 className="wedding-text text-4xl font-bold mb-8 text-center" style={{ color: '#6d5852' }}>
                                            Güzel Dilekleriniz İçin Mektup Yazın
                                        </h4>

                                        {/* Mektup Container */}
                                        <div className="relative">
                                            {/* Mektup Kağıdı */}
                                            <div
                                                className="relative rounded-2xl shadow-2xl transform rotate-1 hover:rotate-0 transition-all duration-500"
                                                style={{
                                                    background: `
                                                        linear-gradient(45deg, #fdfcf8 25%, transparent 25%), 
                                                        linear-gradient(-45deg, #fdfcf8 25%, transparent 25%), 
                                                        linear-gradient(45deg, transparent 75%, #fdfcf8 75%), 
                                                        linear-gradient(-45deg, transparent 75%, #fdfcf8 75%),
                                                        #fefef9
                                                    `,
                                                    backgroundSize: '20px 20px',
                                                    backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px',
                                                    border: '3px solid #e8dcc0',
                                                    boxShadow: `
                                                        0 20px 60px rgba(109, 88, 82, 0.2),
                                                        inset 0 1px 0 rgba(255,255,255,0.8),
                                                        inset 0 -1px 0 rgba(109, 88, 82, 0.1)
                                                    `
                                                }}
                                            >
                                                {/* Vintage Çerçeve */}
                                                <div className="absolute inset-4 border-2 border-amber-300/30 rounded-xl pointer-events-none"></div>
                                                <div className="absolute inset-6 border border-amber-200/40 rounded-lg pointer-events-none"></div>

                                                {/* Dekoratif köşe süslemeleri */}
                                                <div className="absolute top-4 left-4 w-8 h-8 opacity-30">
                                                    <svg viewBox="0 0 100 100" className="w-full h-full" fill="#c17557">
                                                        <path d="M20,20 Q50,10 80,20 Q90,50 80,80 Q50,90 20,80 Q10,50 20,20 Z" />
                                                    </svg>
                                                </div>
                                                <div className="absolute top-4 right-4 w-8 h-8 opacity-30 transform rotate-90">
                                                    <svg viewBox="0 0 100 100" className="w-full h-full" fill="#c17557">
                                                        <path d="M20,20 Q50,10 80,20 Q90,50 80,80 Q50,90 20,80 Q10,50 20,20 Z" />
                                                    </svg>
                                                </div>
                                                <div className="absolute bottom-4 left-4 w-8 h-8 opacity-30 transform rotate-270">
                                                    <svg viewBox="0 0 100 100" className="w-full h-full" fill="#c17557">
                                                        <path d="M20,20 Q50,10 80,20 Q90,50 80,80 Q50,90 20,80 Q10,50 20,20 Z" />
                                                    </svg>
                                                </div>
                                                <div className="absolute bottom-4 right-4 w-8 h-8 opacity-30 transform rotate-180">
                                                    <svg viewBox="0 0 100 100" className="w-full h-full" fill="#c17557">
                                                        <path d="M20,20 Q50,10 80,20 Q90,50 80,80 Q50,90 20,80 Q10,50 20,20 Z" />
                                                    </svg>
                                                </div>

                                                {/* Mektup İçeriği */}
                                                <div className="p-12">
                                                    {/* Tarih ve Selam */}
                                                    <div className="text-right mb-8">
                                                        <p className="wedding-text text-lg" style={{ color: '#8b6f61' }}>
                                                            {new Date().toLocaleDateString('tr-TR', {
                                                                year: 'numeric',
                                                                month: 'long',
                                                                day: 'numeric'
                                                            })}
                                                        </p>
                                                    </div>

                                                    {/* Sevgili Cansu & Ali */}
                                                    <div className="mb-6">
                                                        <p className="wedding-text text-2xl" style={{ color: '#6d5852' }}>
                                                            Sevgili Cansu & Ali,
                                                        </p>
                                                    </div>

                                                    {/* İsim Alanı */}
                                                    <div className="mb-6 relative">
                                                        <div className="flex items-center">
                                                            <span className="wedding-text text-lg mr-3" style={{ color: '#8b6f61' }}>İmza:</span>
                                                            <div className="flex-1 relative">
                                                                <input
                                                                    type="text"
                                                                    placeholder="Adınız Soyadınız..."
                                                                    value={letterName}
                                                                    onChange={(e) => setLetterName(e.target.value)}
                                                                    className="w-full bg-transparent border-none border-b-2 border-dotted border-amber-300/60 focus:outline-none focus:border-amber-400 pb-2 text-lg wedding-text font-medium"
                                                                    style={{
                                                                        color: '#6d5852',
                                                                        fontFamily: "'Dancing Script', cursive"
                                                                    }}
                                                                />
                                                                <div className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-amber-300/50 to-transparent"></div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Mesaj Alanı */}
                                                    <div className="mb-8 relative">
                                                        <textarea
                                                            placeholder="Bu özel günde bize olan sevgi ve iyi dileklerinizi paylaşın..."
                                                            value={letterMessage}
                                                            onChange={(e) => setLetterMessage(e.target.value)}
                                                            className="w-full h-40 bg-transparent border-none focus:outline-none text-lg resize-none leading-8 wedding-text"
                                                            style={{
                                                                color: '#6d5852',
                                                                backgroundImage: `
                                                                     repeating-linear-gradient(
                                                                         transparent,
                                                                         transparent 31px,
                                                                         rgba(199, 117, 87, 0.15) 31px,
                                                                         rgba(199, 117, 87, 0.15) 33px
                                                                     )
                                                                 `,
                                                                backgroundPosition: '0 8px',
                                                                fontFamily: "'Dancing Script', cursive",
                                                                fontSize: '18px'
                                                            }}
                                                        ></textarea>


                                                    </div>

                                                    {/* Kapanış */}
                                                    <div className="text-right mb-6">
                                                        <p className="wedding-text text-lg italic" style={{ color: '#8b6f61' }}>
                                                            Sevgi ve saygılarımla...
                                                        </p>
                                                    </div>

                                                    {/* İndir Butonu */}
                                                    <div className="flex justify-center">
                                                        <button
                                                            onClick={downloadLetterAsPDF}
                                                            className="group relative px-8 py-4 text-white rounded-xl font-medium transition-all duration-500 transform hover:scale-105 hover:shadow-2xl flex items-center justify-center overflow-hidden"
                                                            style={{
                                                                background: 'linear-gradient(135deg, #c17557 0%, #d4957a 100%)',
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.target.style.background = 'linear-gradient(135deg, #a8624a 0%, #c17557 100%)';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.target.style.background = 'linear-gradient(135deg, #c17557 0%, #d4957a 100%)';
                                                            }}
                                                        >
                                                            {/* Buton animasyon arka planı */}
                                                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>

                                                            <svg className="w-6 h-6 mr-3 group-hover:scale-110 transition-transform duration-300" fill="currentColor" viewBox="0 0 20 20">
                                                                <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                                                            </svg>
                                                            <span className="relative z-10 wedding-text text-lg">Mektubu İndir</span>
                                                        </button>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Sağ Taraf - Google Haritalar */}
                        <div className="venue-section rounded-2xl p-8 shadow-lg border border-amber-200/40 relative overflow-hidden h-fit">
                            {/* Dekoratif arka plan elementleri */}
                            <div className="absolute top-0 left-0 w-40 h-40 bg-gradient-to-br from-yellow-200/30 to-transparent rounded-full -ml-20 -mt-20 z-0"></div>
                            <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-tl from-amber-200/30 to-transparent rounded-full -mr-10 -mb-10 z-0"></div>

                            <div className="relative z-10">
                                <h3 className="wedding-text text-4xl md:text-5xl mb-8 text-center" style={{ color: '#c17557' }}>
                                    Konum
                                </h3>

                                <div className="map-container h-96 lg:h-[500px] xl:h-[600px] rounded-2xl overflow-hidden shadow-xl border-4 border-white transform hover:scale-[1.01] transition-all duration-500">
                                    <img
                                        src={hotelImage}
                                        alt="Düğün Mekanı - Hotel Görseli"
                                        className="w-full h-full object-cover rounded-lg"
                                        style={{
                                            objectFit: 'cover',
                                            objectPosition: 'center'
                                        }}
                                    />
                                </div>

                                {/* Mekan İsmi ve Konum İkonu */}
                                <div className="mt-6 text-center">
                                    <div
                                        onClick={openInGoogleMaps}
                                        className="inline-flex items-center justify-center space-x-3 cursor-pointer group transition-all duration-300 hover:scale-105 bg-white/80 backdrop-blur-sm rounded-full px-6 py-4 shadow-lg border border-amber-200/50 hover:shadow-xl"
                                        style={{
                                            background: 'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(248,246,243,0.9) 100%)'
                                        }}
                                    >
                                        {/* Konum İkonu */}
                                        <div className="w-8 h-8 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300"
                                            style={{ background: 'linear-gradient(135deg, #c17557 0%, #d4957a 100%)' }}>
                                            <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                            </svg>
                                        </div>

                                        {/* Mekan İsmi */}
                                        <span
                                            className="wedding-text text-xl font-semibold group-hover:text-amber-700 transition-colors duration-300"
                                            style={{ color: '#6d5852' }}
                                        >
                                            Salon Seramoni 3-4
                                        </span>

                                        {/* Harici Link İkonu */}
                                        <div className="w-5 h-5 opacity-60 group-hover:opacity-100 transition-opacity duration-300">
                                            <svg className="w-full h-full" style={{ color: '#c17557' }} fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                                            </svg>
                                        </div>
                                    </div>

                                    {/* Alt açıklama */}
                                    <p className="mt-3 text-sm opacity-70" style={{ color: '#8b6f61' }}>
                                        Haritada görüntülemek için tıklayın
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>

            {/* Footer Section */}
            <footer className="relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #6d5852 0%, #8b6f61 50%, #6d5852 100%)' }}>
                {/* Dekoratif arka plan elementleri */}
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-white to-transparent rounded-full -ml-48 -mt-48"></div>
                    <div className="absolute top-1/2 right-0 w-80 h-80 bg-gradient-to-bl from-white to-transparent rounded-full -mr-40 -mt-40"></div>
                    <div className="absolute bottom-0 left-1/3 w-64 h-64 bg-gradient-to-tr from-white to-transparent rounded-full -mb-32"></div>
                </div>

                {/* Ana footer içeriği */}
                <div className="relative z-10 max-w-6xl mx-auto px-4 py-16">
                    {/* Üst kısım - Ana mesaj */}
                    <div className="text-center mb-12">
                        {/* Kalp ikonu */}
                        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full mb-6 shadow-2xl animate-pulse"
                            style={{ background: 'linear-gradient(135deg, #c17557 0%, #e4ddd3 50%, #c17557 100%)' }}>
                            <svg className="w-10 h-10 text-white drop-shadow-lg" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                            </svg>
                        </div>

                        {/* Çiftin isimleri */}
                        <h2 className="wedding-text text-6xl md:text-7xl mb-6 text-white drop-shadow-lg">
                            Cansu & Ali
                        </h2>

                        {/* Teşekkür mesajı */}
                        <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed font-light">
                            "Sevgimizi paylaştığımız bu özel günde bizimle olduğunuz için teşekkür ederiz.
                            Hayatımızın en güzel anında yanımızda olmanız bizim için çok değerli."
                        </p>
                    </div>

                    {/* Orta kısım - İletişim bilgileri */}
                    <div className="grid md:grid-cols-2 gap-8 mb-12">
                        {/* Sol taraf - İletişim */}
                        <div className="text-center md:text-left">
                            <h3 className="wedding-text text-3xl mb-6 text-white">İletişim</h3>
                            <div className="space-y-4">
                                <div className="flex items-center justify-center md:justify-start group">
                                    <div className="w-12 h-12 rounded-full flex items-center justify-center mr-4 transition-all duration-300 group-hover:scale-110"
                                        style={{ background: 'linear-gradient(135deg, #c17557 0%, #d4957a 100%)' }}>
                                        <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                                            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                        </svg>
                                    </div>
                                    <a href="tel:+905551234567" className="text-white/90 hover:text-white text-lg transition-all duration-300 group-hover:translate-x-2">
                                        +90 555 123 45 67
                                    </a>
                                </div>

                                <div className="flex items-center justify-center md:justify-start group">
                                    <div className="w-12 h-12 rounded-full flex items-center justify-center mr-4 transition-all duration-300 group-hover:scale-110"
                                        style={{ background: 'linear-gradient(135deg, #c17557 0%, #d4957a 100%)' }}>
                                        <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                                            <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                        </svg>
                                    </div>
                                    <a href="mailto:cansu.ali@wedding.com" className="text-white/90 hover:text-white text-lg transition-all duration-300 group-hover:translate-x-2">
                                        cansu.ali@wedding.com
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Sağ taraf - Özel mesaj */}
                        <div className="text-center md:text-right">
                            <h3 className="wedding-text text-3xl mb-6 text-white">Aşkımızın Tanığı Olun</h3>
                            <p className="text-white/80 text-lg leading-relaxed mb-6">
                                Bu güzel yolculukta bizimle birlikte olmanız,
                                hayatımızdaki en mutlu anları daha da özel kılıyor.
                            </p>


                        </div>
                    </div>

                    {/* Alt çizgi */}
                    <div className="border-t border-white/20 pt-8">
                        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                            {/* Sol taraf - Copyright */}
                            <div className="text-white/70 text-sm flex items-center">
                                © 2025 Cansu & Ali Düğün Davetiyesi
                            </div>

                            {/* Orta - Özel mesaj */}
                            <div className="text-white/60 text-sm italic wedding-text">
                                "Aşk, iki kalbin bir ritimde atmasıdır"
                            </div>

                            {/* Sağ taraf - Powered by */}
                            <div className="text-white/70 text-sm flex items-center">
                                Projeyi geliştiren
                                <span className="ml-2 px-2 py-1 rounded-full text-xs font-semibold text-white"
                                    style={{ background: 'linear-gradient(135deg, #c17557 0%, #d4957a 100%)' }}>
                                    DijiVite ❤️
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Alt dekoratif çiçekler */}
                <div className="absolute bottom-0 left-0 w-full h-32 overflow-hidden opacity-20">
                    <div className="absolute bottom-0 left-10 w-24 h-24 flower-animation" style={{ animationDelay: '0s' }}>
                        <img src={flowerImage} alt="Çiçek" className="w-full h-full object-contain" />
                    </div>
                    <div className="absolute bottom-0 right-32 w-20 h-20 flower-animation" style={{ animationDelay: '1s' }}>
                        <img src={flowerImage} alt="Çiçek" className="w-full h-full object-contain transform scale-75" />
                    </div>
                    <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-16 h-16 flower-animation" style={{ animationDelay: '2s' }}>
                        <img src={flowerImage} alt="Çiçek" className="w-full h-full object-contain transform scale-50" />
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Wedding2;
